import React from 'react'
import { ReactComponent as AccountActiveIcon } from '@svgs/keyline/menu-account-active.svg'
import { ReactComponent as AccountIcon } from '@svgs/keyline/menu-account.svg'
import styles from './styles.module.scss'

const AccountMenuIcon = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  return (
    <span
      className={`${styles.accountMenuIcon} ${isLoggedIn ? styles.loggedIn : ''}
        
`}
    >
      {isLoggedIn ? <AccountActiveIcon /> : <AccountIcon />}
    </span>
  )
}

export default AccountMenuIcon
